// features/interoperabilidad/api/renapo.api.js
// Consulta de datos de personas por CURP usando el hub de interoperabilidad

import { api } from '../../../api/client';

export const renapoApi = {
  /** Consulta datos de una persona por CURP en RENAPO */
  getByCurp: (curp) =>
    api.get(`/users/validate-curp/${curp}`),

  /** Consulta directamente el servicio RENAPO por CURP */
  getPersonByCurp: (curp) =>
    api.get(`/interop/renapo/${encodeURIComponent(curp)}`),

  // test con la conf guardada
  testSaved:(data)=>
    api.post(`/interop/renapo/test/saved`,data),
  testConfigActive:()=>
    api.post(`/interop/renapo/test/saved`),
  testThisConfig:(data)=>
    api.post(`/interop/renapo/test/thisConfig`,data)
};
